import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { API_URL } from '../../constants';
import { AuthContext } from "../AuthContext";
import { useNavigate } from "react-router-dom";
import withAuth from "../../auth";
import Spinner from "react-bootstrap/Spinner";
import echo from "../../echo";

const WebSocketsTest = () => {
    const { token, setToken, hasPermission } = useContext(AuthContext);
    const navigate = useNavigate();
    const [success, setSuccess] = useState('');
    const [error, setError] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        const channel = 'np-admin-websockets-test';

        const setupListener = () => {
            echo.channel(channel)
                .listen('.App\\Events\\Admin\\WebsocketsTest', (event) => {
                    console.log('event.message', event.message);
                    if (!event.message) return;
                    setSuccess(event.message);
                    setTimeout(() => {
                        setSuccess('');
                    }, 5000);
                });
        };

        // Wait for connection before binding
        if (echo.connector.socket.connected) {
            setupListener();
        } else {
            echo.connector.socket.on('connect', setupListener);
        }

        return () => {
            echo.leave(channel);
        };
    }, []);

    const handleError = (error) => {
        if (error.response && error.response.status === 401) {
            localStorage.removeItem('authToken');
            setToken(null);
            navigate('/');
        }
        if (error?.response?.data?.errors) {
            const errors = error.response.data.errors;
            const errorMessages = Object.keys(errors).map(key => errors[key].join(' ')).join(' ');
            setError(errorMessages);
        } else if (error?.response?.data?.message) {
            setError(error.response.data.message);
        } else {
            setError('An error occurred. Please try again later.');
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        setIsSubmitting(true);
        try {
            const response = await axios.post(`${API_URL}/api/admin/websockets/test`, {}, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            // if (response.data.message) {
            //     setSuccess(response.data.message);
            // }
        } catch (error) {
            handleError(error);
            if (error?.response?.data?.errors) {
                const errors = error.response.data.errors;
                const errorMessages = Object.keys(errors).map(key => errors[key].join(' ')).join(' ');
                setError(errorMessages);
            } else if (error?.response?.data?.message) {
                setError(error.response.data.message);
            } else {
                setError('An error occurred. Please try again later.');
            }
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="container mt-5">
            <h1 className="text-center">Test WebSockets</h1>
            {error && <div className="alert alert-danger">{error}</div>}
            {success && <div className="alert alert-success">{success}</div>}
            <div className="card mb-4">
                <div className="card-body">
                    <form onSubmit={(e) => handleSubmit(e)}>
                        <div className="d-flex">
                            <button type="submit" className="btn btn-primary mx-auto" disabled={isSubmitting}>
                                {isSubmitting
                                    ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                                    : 'Test'
                                }
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default withAuth(WebSocketsTest);
